
import { Control } from "@/types/controls";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Control_ from "./Control.vue";

@Component({
  name: "ControlsTreeLinear",
  components: {
    Control: Control_,
    ControlsTreeLinear: ControlsTreeLinear
  }
})
export default class ControlsTreeLinear extends Vue {
  @Prop({
    default: ""
  })
  prependLabel!: string;

  @Prop()
  controls!: Control[];

  @Prop()
  path!: string;

  get isTopLevel() {
    return !this.path.includes(".");
  }

  onlyContainsSubSections(control: Control) {
    return control.children.every(child => child.options.type === "section");
  }

  breadcrumbs(control: Control) {
    return this.isTopLevel ? "" : `${this.prependLabel} ${control.label} / `;
  }
}
